import { parseMessage } from '@src/locales/intl';
import { DepartmentState, DepartmentType } from '@src/types';

const lblDepartmentName = parseMessage(
  'Console.Transfer.AgentsWithoutDepartment.Text'
);

export const departmentWithoutAgents = {
  botId: 0,
  departmentCode: lblDepartmentName,
  departmentId: 0,
  hasFaqsEnabled: false,
  hasSatisfactionEnabled: false,
  hiddenToContacts: true,
  name: lblDepartmentName,
  parentNodeId: null,
  state: DepartmentState.ACTIVE,
  type: DepartmentType.DEPARTMENT,
};

export default departmentWithoutAgents;
